// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"268":"6e33d973","339":"8abc95dc","453":"ed251ffc","457":"25208eff","629":"49635671","638":"5f202670","640":"cad1214b","828":"b962baff","842":"b230433e"}[chunkId] + ".chunk.js";
};